var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 106,
    viewBox: "0 0 92 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1432 51.6708H36.8455C16.6303 51.6708 0.25 63.4478 0.25 77.9709V91.117C0.25 105.64 16.6303 105.632 36.8455 105.632H55.1432C75.3585 105.632 91.7388 105.632 91.7388 91.117V77.9709C91.7388 63.4478 75.3585 51.6708 55.1432 51.6708ZM46.0441 45.5702C51.0964 45.5702 56.0352 44.2439 60.2358 41.7592C64.4365 39.2745 67.7103 35.743 69.6433 31.6112C71.5763 27.4794 72.0817 22.9331 71.0954 18.5471C70.109 14.1611 67.6754 10.1325 64.1023 6.97086C60.5292 3.80921 55.9771 1.65651 51.0217 0.785027C46.0663 -0.0864533 40.9303 0.362434 36.2631 2.0749C31.5959 3.78738 27.6074 6.68651 24.8018 10.4056C21.9962 14.1248 20.4997 18.4968 20.5014 22.9689C20.5014 25.9376 21.1622 28.8772 22.4459 31.6199C23.7297 34.3625 25.6113 36.8544 27.9833 38.9532C30.3553 41.0521 33.1711 42.7167 36.2701 43.852C39.369 44.9874 42.6902 45.5712 46.0441 45.5702Z",
    fill: "#777777"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCamera);
export default __webpack_public_path__ + "static/media/userCamera.b8764d6b.svg";
export { ForwardRef as ReactComponent };